import { render } from "./PersonalSecurity.vue?vue&type=template&id=0aa9d3da&scoped=true"
import script from "./PersonalSecurity.vue?vue&type=script&lang=js"
export * from "./PersonalSecurity.vue?vue&type=script&lang=js"

import "./PersonalSecurity.vue?vue&type=style&index=0&id=0aa9d3da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa9d3da"]])

export default __exports__